export default {"src":"https://s.sylndr.com/c-9cd064a/_next/static/media/plus-green-icon.233922eb.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};